let pbjsLoadPromise = null;

export function ensurePbjsLoaded(src, integrity = null) {
  if (typeof window !== 'undefined' && window.pbjs) {
    return Promise.resolve(window.pbjs);
  }

  if (!src) {
    return Promise.resolve(false);
  }

  if (pbjsLoadPromise) {
    return pbjsLoadPromise;
  }

  pbjsLoadPromise = new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      resolve(false);
      return;
    }

    const scriptTag = document.createElement('script');
    scriptTag.src = src;
    scriptTag.async = true;
    scriptTag.type = 'text/javascript';

    // Add integrity and crossorigin attributes for security when integrity is provided
    if (integrity) {
      scriptTag.integrity = integrity;
      scriptTag.crossOrigin = 'anonymous';
    }

    scriptTag.onerror = err => {
      pbjsLoadPromise = null;
      reject(err);
    };

    scriptTag.onload = () => {
      resolve(window.pbjs || false);
    };

    document.head.appendChild(scriptTag);
  });

  return pbjsLoadPromise;
}
